import { NgModule } from '@angular/core';
import { SidenavComponent } from './shared/components/sidenav/sidenav.component';
import { LoginGuard } from './core/guards/login.guard';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './shared/components/home/home.component';
import { RouterModule, Routes } from '@angular/router';
import { ImportacionGuard } from './core/guards/importacion.guard';
import { RoleGuard } from './core/guards/role.guard';
import {
	IMPORTACION_CONSULTAR,
	VERIFICACION_CONSULTAR
} from './shared/constants/importacion-permisos';

const routes: Routes = [
	{
		path: '',
		component: SidenavComponent,
		children: [
			{
				path: 'importacion',
				canActivate: [MsalGuard, ImportacionGuard, RoleGuard],
				loadChildren: () =>
					import('./modules/importacion/importacion.module').then(
						m => m.ImportacionModule
					),
				data: {
					breadcrumb: 'Importación',
					permissions: [IMPORTACION_CONSULTAR, VERIFICACION_CONSULTAR]
				}
			},
			{
				path: '',
				redirectTo: 'security',
				pathMatch: 'full'
			},
			{
				path: 'security',
				canActivate: [MsalGuard],
				loadChildren: () =>
					import('./modules/security/security.module').then(
						children => children.SecurityModule
					),
				data: { breadcrumb: 'Seguridad' }
			},
			{
				path: 'company-profile',
				canActivate: [MsalGuard],
				loadChildren: () =>
					import('./modules/company-profile/company-profile.module').then(
						children => children.CompanyProfileModule
					),
				data: { breadcrumb: 'Perfil Empresa' }
			},
			{
				path: 'audit',
				canActivate: [MsalGuard],
				loadChildren: () =>
					import('./modules/audit/audit.module').then(
						children => children.AuditModule
					),
				data: { breadcrumb: 'Auditoría' }
			},
			{
				path: 'establishment',
				canActivate: [MsalGuard],
				loadChildren: () =>
					import('./modules/establishment/establishment.module').then(
						children => children.EstablishmentModule
					),
				data: { breadcrumb: 'Unidades Productivas' }
			},
			{
				path: 'traceability',
				canActivate: [MsalGuard],
				loadChildren: () =>
					import('./modules/traceability/traceability.module').then(
						children => children.TraceabilityModule
					),
				data: { breadcrumb: 'Trazabilidad' }
			},
			{
				path: 'shipment',
				canActivate: [MsalGuard],
				loadChildren: () =>
					import('./modules/shipment/shipment.module').then(
						children => children.ShipmentModule
					),
				data: { breadcrumb: 'Embarques' }
			},
			{
				path: 'stock',
				canActivate: [MsalGuard],
				loadChildren: () =>
					import('./modules/stock/stock.module').then(
						children => children.StockModule
					),
				data: { breadcrumb: 'Stock' }
			},
			{
				path: 'tracking',
				canActivate: [MsalGuard],
				loadChildren: () =>
					import('./modules/tracking/tracking.module').then(
						children => children.TrackingModule
					),
				data: { breadcrumb: 'Movimientos' }
			},
			{
				path: 'home',
				canActivate: [MsalGuard],
				loadComponent: () => HomeComponent
			}
		]
	},
	{
		path: 'login',
		canActivate: [LoginGuard],
		loadChildren: () =>
			import('./modules/authentication/authentication.module').then(
				children => children.AuthenticationModule
			)
	},
	{
		path: 'registro-productor',
		loadComponent: () =>
			import(
				'./modules/authentication/registro-productor/registro-productor.component'
			).then(m => m.RegistroProductorComponent)
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {}
